/**
 * Hardcoded row handler definition until obtained from server metadata.
 */

const RowHandlerDef = {
  Compare: {entries: [{name: 'Leave Date'}, {name: 'Join Date'}], args: [{name: 'op', value: '>'}]},
  LeftEmploymentStatus: {entries: [{name:'LeftEmploymentStatus'}]}
}

export default RowHandlerDef;